<template>
  <div>
    <a-modal
      width="1000px"
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="新增"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 3 }"
        :wrapper-col="{ span: 20 }"
        @submit="handleSubmit"
      >
        <a-form-item label="公告标题">
          <a-input
            v-decorator="['title', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入公告标题' },
                { max: 200, message: '最多200个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="公告内容">
          <wang-editor
            v-decorator="['content', {
              rules: [
                { required: true, message: '请输入公告内容' },
                { max: 65535, message: '最多65535个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="立即发布">
          <a-checkbox
            v-decorator="['is_publish_immediately', { valuePropName: 'checked' }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { createAnnouncement } from '@/api/announcement'
import WangEditor from '@/components/Editor/WangEditor'

export default {
  name: 'NewAnnouncement',
  components: {
    WangEditor
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'announcement' }),
      submitting: false,
      roleOptions: []
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          createAnnouncement(values).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
